import Vue from 'vue';
import Vuex from 'vuex';
import { http } from '@/utils';
import baseUrl from '../utils/api';
import { fetchSchoolInfo, fetchSchoolSdk } from '@/api/school';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    school: [], // 校区列表
    choicesSchool: null, // 选中的校区
    apiUrl: baseUrl,
    appId: 4,
    roleList: null,
    schoolCategory: [],
    grade: [ // 年级
      { value: 1, label: '幼儿' },
      { value: 2, label: '小学' },
      { value: 3, label: '中学' },
      { value: 4, label: '高中' },
      { value: 5, label: '其他' },
    ],
    length: '',
    user: {},
    mainUser: {},
    schoolInfo: {}, // 校区详情
    resourcesToken: null,
    schoolCenter: false,
    courseAuth: [], // 课程授权
    accountAuth: [], // 授权账号
    schoolSdkInfo: {}, // 校区sdk信息
  },
  mutations: {
    initSchoolList(state, school) { // 校区列表
      state.school = school.school;
    },
    setChoicesSchool(state, school) { // 选中的校区
      state.choicesSchool = school;
      fetchSchoolInfo(school.id).then((vl) => {
        state.schoolInfo = vl;
      });
      fetchSchoolSdk(school.id).then((vl) => {
        state.schoolSdkInfo = vl.data;
      });
    },
    setApiUrl(state, url) { // 校区api地址
      state.apiUrl = url;
    },
    initUser(state, user) { // 初始化用户信息
      state.user = user;
    },
    initMainUser(state, user) { // 初始化主体账号信息
      state.mainUser = user;
    },
    setLength(state, length) {
      state.length = length;
    },
    setResourcesToken(state, res) {
      state.resourcesToken = res;
    },
    setCourseAuth: (state, courseAuth) => {
      state.courseAuth = courseAuth;
    },
    setAccountAuth: (state, accountAuth) => {
      state.accountAuth = accountAuth;
    },
  },
  actions: {
    initUser({ commit }, val) {
      http.get('/api/user')
        .then((res) => {
          commit('initUser', res);
        });
    },
    initMainUser({ commit }) {
      http.get(`${baseUrl}/api/users`)
        .then(res => commit('initMainUser', res));
    },
    setCourseAuth({
      commit,
    }, courseAuth) {
      commit('setCourseAuth', courseAuth);
    },
    setAccountAuth({
      commit,
    }, accountAuth) {
      commit('setAccountAuth', accountAuth);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js